import React, { useState, useEffect } from 'react';
import Loading from '../components/Loading';
import axios from 'axios';
import OfficeInfo from '../components/detail/OfficeInfo';
import '../styles/pages/emp-details.scss';
import ErrorPage from './error';
import ProfileImage from '../components/ProfileImage';
import { useTranslation } from 'react-i18next';
import { OFFICE_DETAILS_BACK_BUTTON, OFFICE_DETAILS_INFORMATION_LABEL } from '../i18n/keyConstants';

const CancelToken = axios.CancelToken;
let cancel;

const OfficeDetails = ({ officeId }) => {
    const [office, setOffice] = useState();
    const [id] = useState(officeId);

    const [loading, setIsLoading] = useState(true);
    const [error, setError] = useState();

    const { t } = useTranslation(['officeDetails']);

    useEffect(() => {
        function fetchOffice() {
            const url = `api/office/${id}`;

            cancel && cancel();

            try {
                axios
                    .get(url, {
                        cancelToken: new CancelToken((c) => {
                            cancel = c;
                        }),
                    })
                    .then((response) => {
                        const office = response.data;

                        setOffice(office);
                        setIsLoading(false);
                    })
                    .catch((thrown) => {
                        if (axios.isCancel(thrown)) {
                            console.warn('Request canceled', thrown.message);
                        } else {
                            const error = thrown.response;
                            setError(error);
                            setIsLoading(false);
                        }
                    });
            } catch (error) {
                console.error(error);
            }
        }
        fetchOffice();
    }, [id]);

    const content = loading ? (
        <Loading />
    ) : error && error ? (
        <ErrorPage error={error} />
    ) : (
        <section className='details'>
            <div className='card-body bg-light-licorice'>
                <div className='card-profile-img text-center margin-bottom-10px margin-top-10px'>
                    <img className='margin-none' src={ProfileImage} alt='' />
                </div>
                <h3 className='text-center c-white margin-bottom-none'>{office.nam}</h3>
                <p className='text-center c-light-grey'>{}</p>
                <span className='details-back-btn'>
                        <button className='btn btn-outline-secondary d-flex c-white border-0' onClick={() => window.history.back()}>
                        <span className='oi oi-chevron-left padding-right-10px'></span>
                                <span className='d-none d-sm-block'>{t(OFFICE_DETAILS_BACK_BUTTON)}</span>
                    </button>
                </span>
            </div>

            <ul className='nav nav-tabs container padding-top-15px' role='tablist'>
                <li className='nav-item'>
                    <a
                        className='nav-link active'
                        id='info-tab'
                        data-toggle='tab'
                        href='#info'
                        role='tab'
                        aria-controls='info'
                        aria-selected='true'>
                        {t(OFFICE_DETAILS_INFORMATION_LABEL)}
                    </a>
                </li>
            </ul>

            <div className='tab-content'>
                <div className='tab-pane fade show active' id='info' role='tabpanel' aria-labelledby='info-tab'>
                    <OfficeInfo office={office} />
                </div>
            </div>
        </section>
    );
    return content;
};

export default OfficeDetails;
